import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import type { GetLibraryQuery } from '@/pages/Dashboard/hooks/useLibrary.generated';
import { createLibraryQueryKey } from '@/utils/queryKeys';

// Prefix key: writes must hit every library query (personal and org contexts,
// with or without an event id), not just the bare personal one.
const queryKey = createLibraryQueryKey();

export const useLibraryCache = () => {
  const queryClient = useQueryClient();

  const removeLibraryItem = useCallback(
    (id: string) => {
      queryClient.setQueriesData<GetLibraryQuery | undefined>(
        { queryKey },
        (oldData) => {
          if (!oldData) {
            return oldData;
          }
          return {
            ...oldData,
            getLibrary: oldData.getLibrary.filter((item) => item.id !== id),
          };
        }
      );
    },
    [queryClient]
  );

  const updateLibraryItemTitle = useCallback(
    (id: string, title: string) => {
      queryClient.setQueriesData<GetLibraryQuery | undefined>(
        { queryKey },
        (oldData) => {
          if (!oldData) {
            return oldData;
          }
          return {
            ...oldData,
            getLibrary: oldData.getLibrary.map((item) =>
              item.id === id ? { ...item, title } : item
            ),
          };
        }
      );
    },
    [queryClient]
  );

  return {
    removeLibraryItem,
    updateLibraryItemTitle,
  };
};
